interface CategoryDetailSkeletonProps {
  headerBackground?: string;
}

export default function CategoryDetailSkeleton({ headerBackground }: CategoryDetailSkeletonProps) {
  return (
    <div className="animate-pulse">
      {/* Back nav skeleton — matches loaded back nav structure */}
      <div style={{ backgroundColor: headerBackground }}>
        <div
          className="flex items-center gap-2 py-4 bg-white px-6 w-full"
          style={{ borderTopLeftRadius: 24, borderTopRightRadius: 24 }}
        >
          <div className="w-6 h-6 bg-[#C7EDEF] rounded" />
          <div className="h-6 bg-[#C7EDEF] rounded w-48" />
        </div>
      </div>

      <div className="flex flex-col gap-6 px-6 py-4">
      {/* Stage badge skeleton */}
      <div className="h-7 bg-[#C7EDEF] rounded-xl w-32" />

      {/* Narrative skeleton */}
      <div className="flex flex-col gap-2">
        <div className="h-4 bg-[#C7EDEF] rounded w-full" />
        <div className="h-4 bg-[#C7EDEF] rounded w-full" />
        <div className="h-4 bg-[#C7EDEF] rounded w-5/6" />
        <div className="h-4 bg-[#C7EDEF] rounded w-4/5" />
      </div>

      {/* Date section skeleton */}
      <div className="flex flex-col gap-3">
        <div className="h-4 bg-[#C7EDEF] rounded w-64" />
        <div className="h-5 bg-[#C7EDEF] rounded w-40" />
        <div className="h-4 bg-[#C7EDEF] rounded w-48" />
        <div className="h-5 bg-[#C7EDEF] rounded w-24" />
      </div>

      {/* Retake button skeleton */}
      <div className="h-12 bg-[#C7EDEF] rounded-xl" />
      </div>
    </div>
  );
}
